import { useMutation } from 'react-query'
import { post, postAPI } from 'framework/api/http'

interface ICSRetryFailedConsignmentInterface {
  splitReference?: string
  wmsOrderNo: string
}

export const useICSRetryFailedConsignment = () => {
  const mutate = useMutation(
    ({ splitReference, wmsOrderNo }: ICSRetryFailedConsignmentInterface) => {
      return postAPI(`ICSBulkConsignment/RetryFailedICSConsignedOrder`, {
        splitReference: splitReference,
        wmsOrderNo: wmsOrderNo,
      })
    },
  )
  return mutate
}

export default useICSRetryFailedConsignment
